import Jed from 'jed';
import once from 'lodash/once';

// This is a port of the I18n module from Orderweb. Not entirely sure how it works
// or why it's set up this way and should be reviewed in the future.

let i18n = new Jed({});

const init = (translations = {}) => {
  i18n = new Jed({
    ...translations,
    missing_key_callback: (key) => {
      // eslint-disable-next-line no-console
      console.warn(`"${key}" is missing from translations`);
    },
  });
};

const checkTranslationsWereProvided = once(() => {
  // If i18n.init hasn't been called this will warn
  if (Object.keys(i18n.options.locale_data.messages).length <= 1) {
    // eslint-disable-next-line no-console
    console.warn(
      'No i18n translations provided to Jed. If you see this in production start worrying now.',
    );
  }
});

const gettext = (key, ...args) => {
  checkTranslationsWereProvided();
  if (args.length > 0) {
    const translatedKey = i18n.gettext(key);
    return i18n.sprintf.apply(i18n, [translatedKey, ...args]);
  }
  return i18n.gettext(key);
};

const ngettext = (key, ...args) => {
  checkTranslationsWereProvided();
  const translated = i18n.ngettext.apply(i18n, [key, ...args]);
  if (args.length === 3) {
    if (typeof translated !== 'string') {
      return i18n.sprintf(translated[0], args[2]);
    }
    return i18n.sprintf(translated, args[2]);
  }
  return translated;
};

const language = () => {
  checkTranslationsWereProvided();
  return i18n.options.locale_data.messages[''].lang;
};

const restore = () => {
  i18n = new Jed({});
};

export default {
  init,
  gettext,
  ngettext,
  restore,
  language,
};
